import { cn } from "@btnet/utilities-core";

import { BdsText } from "@buildertrend/components";

import { BTUser } from "commonComponents/btWrappers/BTUser/BTUser";
import { useFormatDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate.utilities";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

import { type ISnapshotVersionItem } from "./SnapshotVersionHistory.types";

interface ISnapshotVersionHistoryRowProps {
    version: ISnapshotVersionItem;
    isSelected: boolean;
    onSelect: (version: ISnapshotVersionItem) => void;
}

export function SnapshotVersionHistoryRow({
    version,
    isSelected,
    onSelect,
}: Readonly<ISnapshotVersionHistoryRowProps>) {
    const formatDate = useFormatDate();

    return (
        <div
            role="button"
            tabIndex={0}
            className={cn("SnapshotVersionHistoryRow", { Selected: isSelected })}
            onClick={() => onSelect(version)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSelect(version);
                }
            }}
            data-testid={`snapshotVersionHistoryRow-${version.versionNumber}`}
        >
            <div className="flex flex-row gap-3 pl-4 pr-3 py-1 items-center">
                <div className="flex flex-col w-10 min-w-10 items-center">
                    <BdsText
                        size="normal-md"
                        text={String(version.versionNumber)}
                        testid={`versionNumber-${version.versionNumber}`}
                    />
                </div>
                <div className={cn("flex flex-col", "grow", "w-25", "py-2", "gap-2")}>
                    <TextTruncate>
                        {formatDate(new Date(version.date), {
                            showDate: true,
                            showTime: true,
                            showDayOfWeek: false,
                        })}
                    </TextTruncate>
                    {version.user && version.user.globalUserId > 0 && (
                        <BTUser
                            globalUserId={version.user.globalUserId}
                            displayName={version.user.displayName}
                            type="full"
                            size="small"
                        />
                    )}
                    {version.description && <BdsText size="normal-sm" text={version.description} />}
                </div>
            </div>
        </div>
    );
}
